
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"512","height":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.853 1.148a3.626 3.626 0 00-5.124 0L1.465 17.412A4.968 4.968 0 000 20.947V23a1 1 0 001 1h2.053a4.966 4.966 0 003.535-1.464L22.853 6.271a3.626 3.626 0 000-5.123zM5.174 21.122A3.022 3.022 0 013.053 22H2v-1.053a2.98 2.98 0 01.879-2.121L15.222 6.483l2.3 2.3zM21.438 4.857l-2.506 2.507-2.3-2.295 2.507-2.507a1.623 1.623 0 112.295 2.3z"}})])
          )
        }
      }
    